<template>
  <div class="demo-tabs-style2">
    <Tabs
      type="card"
      :animated="false"
      name="tab1"
      :value="tabValue"
      @on-click="tabClick"
      :lazy="true"
    >
      <!-- 绩效评估 -->
      <TabPane
        :label="$t('Performance_Appraisal')"
        v-if="this.$route.query.plan == '1' || this.$route.query.plan == '3'"
        tab="tab1"
        name="1"
      >
        <PerformanceEvaluation
          ref="PerformanceEvaluation"
        ></PerformanceEvaluation>
      </TabPane>
      <!--People Board 绩效评估 -->
      <TabPane
        :label="$t('Talent_Review_PB')"
        v-if="this.$route.query.plan == '4'"
        tab="tab1"
        name="1"
      >
        <PerformanceEvaluation2
          ref="PerformanceEvaluation2"
        ></PerformanceEvaluation2>
      </TabPane>
      <!-- 继任盘点 -->
      <TabPane
        :label="$t('PB_Succession')"
        v-if="['1', '2', '4'].includes($route.query.plan)"
        tab="tab1"
        name="2"
      >
        <SuccessionInventory ref="SuccessionInventory"></SuccessionInventory>
      </TabPane>
      <!-- 人才标签 -->
      <TabPane
        :label="$t('Talent Tag')"
        v-if="this.$route.query.plan == '1'"
        tab="tab1"
        name="3"
      >
        <CapabilityAssessment ref="CapabilityAssessment"></CapabilityAssessment>
      </TabPane>
      <!-- 团队概览 -->
      <TabPane
        :label="$t('PB_Team_Overview')"
        v-if="['1', '2', '4'].includes($route.query.plan)"
        tab="tab1"
        name="4"
      >
        <TeamOverview ref="TeamOverview"></TeamOverview>
      </TabPane>
    </Tabs>

    <!-- <div style="margin:20px 0;display:flex;justify-content: center;">
            <Button type="primary" @click="returnPage">返回</Button>
        </div> -->
  </div>
</template>

<script>
import PerformanceEvaluation from "./PeopleBoardComponents/PerformanceEvaluation.vue";
import PerformanceEvaluation2 from "./PeopleBoardComponents/PerformanceEvaluation2.vue";
import SuccessionInventory from "./PeopleBoardComponents/SuccessionInventory.vue";
import CapabilityAssessment from "./PeopleBoardComponents/CapabilityAssessment.vue";
import TeamOverview from "./PeopleBoardComponents/TeamOverview.vue";

export default {
  components: {
    PerformanceEvaluation,
    PerformanceEvaluation2,
    SuccessionInventory,
    CapabilityAssessment,
    TeamOverview,
  },
  data() {
    return {
      tabValue: "1",
    };
  },
  mounted() {
    // this.$route.query.plan?this.tabValue=this.$route.query.plan:'1'
    // if(this.tabValue=='1'){
    //         this.$nextTick(() => {
    //         this.$refs.PerformanceEvaluation.showreturnbtn=true
    //         this.$refs.PerformanceEvaluation.id=this.$route.query.id
    //         this.$refs.PerformanceEvaluation.beEnd=this.$route.query.beEnd
    //         this.$refs.PerformanceEvaluation.getData()
    //         this.$refs.PerformanceEvaluation.getListData()
    //     })
    // }
    this.$store.getters.tabValueData
      ? (this.tabValue = this.$store.getters.tabValueData)
      : "";
    // if(this.$route.query.plan=='2'){
    //     this.$nextTick(() => {
    //         this.$refs.SuccessionInventory.showreturnbtn=true
    //     })
    // }
    if (this.$route.query.plan == "1") {
      this.$nextTick(() => {
        this.$refs.PerformanceEvaluation.showreturnbtn = true;
        this.$refs.PerformanceEvaluation.id = this.$route.query.id;
        this.$refs.PerformanceEvaluation.beEnd = this.$route.query.beEnd;
        this.$refs.SuccessionInventory.meetingName =
          this.$route.query.meetingName;
        // this.$refs.PerformanceEvaluation.getData()
        this.$refs.PerformanceEvaluation.getListData();
        this.$refs.CapabilityAssessment.id = this.$route.query.id;
        // this.$refs.CapabilityAssessment.getData()
        this.$refs.CapabilityAssessment.getListData();
        this.$refs.CapabilityAssessment.beEnd = this.$route.query.beEnd;
        this.$refs.TeamOverview.id = this.$route.query.id;
        // this.$refs.TeamOverview.getData()
      });
    }
    if (
      this.$route.query.plan == "1" ||
      this.$route.query.plan == "2" ||
      this.$route.query.plan == "4"
    ) {
      this.$nextTick(() => {
        this.$refs.SuccessionInventory.id = this.$route.query.id;
        this.$refs.SuccessionInventory.id = this.$route.query.id;
        this.$refs.TeamOverview.id = this.$route.query.id;
        // this.$refs.SuccessionInventory.getData()
        this.$refs.SuccessionInventory.showreturnbtn = true;
      });
    }
    // 绩效校准会
    if (this.$route.query.plan == "3") {
      this.$nextTick(() => {
        this.$refs.PerformanceEvaluation.showreturnbtn = true;
        this.$refs.PerformanceEvaluation.id = this.$route.query.id;
        this.$refs.PerformanceEvaluation.beEnd = this.$route.query.beEnd;
        this.$refs.PerformanceEvaluation.showDiv = false;
        this.$refs.PerformanceEvaluation.showDiv2 = true;
        // this.$refs.PerformanceEvaluation.getData()
        this.$refs.PerformanceEvaluation.getListData();
      });
    }
    if (this.$route.query.plan == "4") {
      this.tabValue = "1";
      this.$refs.PerformanceEvaluation2.id = this.$route.query.id;
      this.$refs.SuccessionInventory.id = this.$route.query.id;
      this.$refs.PerformanceEvaluation2.getListData();
      this.$refs.PerformanceEvaluation2.showreturnbtn = true;

    }
    if (this.$route.query.plan == "2") {
      this.tabValue = "2";
    }
    // 查看继任者 返回
    if(sessionStorage.getItem("Teamback")) {
      this.tabValue = "2";
      sessionStorage.removeItem("Teamback")
    }

    this.$nextTick(() => {
      if (this.tabValue == "1") {
        if (this.$route.query.plan == "4") {
          this.$refs.PerformanceEvaluation2.getData();
        } else {
          this.$refs.PerformanceEvaluation.getData();
        }
      } else if (this.tabValue == "2") {
        this.$refs.SuccessionInventory.getData();
      } else if (this.tabValue == "3") {
        this.$refs.CapabilityAssessment.getData();
      } else if (this.tabValue == "4") {
        this.$refs.TeamOverview.getData();
      }
    });
  },
  methods: {
    returnPage() {
      this.$router.back();
    },
    tabClick(val) {
      this.tabValue = val;
      if (val == "1") {
        if (this.$route.query.plan == "4") {
          this.$refs.PerformanceEvaluation2.getData();
        } else {
          this.$refs.PerformanceEvaluation.getData();
        }
      } else if (val == "2") {
        this.$refs.SuccessionInventory.getData();
      } else if (val == "3") {
        this.$refs.CapabilityAssessment.getData();
      } else if (val == "4") {
        this.$refs.TeamOverview.getData();
      }
      this.$store.state.tabValue = val;
    },
  },
};
</script>

<style>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0;
  background: #459846;
  color: #ffffff;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  /* border-top: 1px solid #ffffff; */
  background: #ffffff;
  border-top: 1px solid #459846 !important;
  border-left: 1px solid #459846 !important;
  border-right: 1px solid #459846 !important;
  color: #333333;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:before {
  /* content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        color: #459846; */
}
/* .card-tabs-search >>>.ivu-tabs.ivu-tabs-card {
    border-color:#8CD29B;
  }
 
  .card-tabs-search >>>.ivu-tabs.ivu-tabs-card >.ivu-tabs-bar .ivu-tabs-tab-active{
    background:#8CD29B;
    color: #f5f7f9;
    height:52px;
    border-color:#8CD29B;
  }
  .card-tabs-search >>>.ivu-tabs.ivu-tabs-card >.ivu-tabs-bar .ivu-tabs-tab-focused{
      border-color:#8CD29B;
  }
  .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
      border-color:#8CD29B;
  } */
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeoPleBoardJump.vue